/**
 * tdesign v1.5.1
 * (c) 2023 tdesign
 * @license MIT
 */

import './dep-34428f12.mjs';
import { a as _getNative } from './dep-5b5daf08.mjs';

var getNative = _getNative;
var defineProperty = function () {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}();
var _defineProperty = defineProperty;

export { _defineProperty as _ };
//# sourceMappingURL=dep-c8679a16.mjs.map
